import React from 'react'
import { Card, Input, Button, Table, Pagination, Form, DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getActualSoldPriceListAPI } from '@/apis/house'
import { checkMenu, checkLogin } from '@/utils'
import Dayjs from 'dayjs'
const { Column } = Table
const { RangePicker } = DatePicker
export default function ActualSoldList() {
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    houseName: '',
    evidenceName: '',
    startTime: '',
    endTime: '',
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  //  获取文章列表
  const [list, setList] = useState()

  const location = useLocation()
  const navigate = useNavigate()


  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  搜索
  const searchFinish = values => {
    console.log('%c [ values ]-78', 'font-size:13px; background:pink; color:#bf2c9f;', values)
    listQuery.houseName = values.houseName
    listQuery.evidenceName = values.evidenceName
    let startTime = ''
    let endTime = ''
    if (values.endtime) {
      startTime = Dayjs(values.endtime[0]).format('YYYY-MM-DD')
      endTime = Dayjs(values.endtime[1]).format('YYYY-MM-DD')
    }
    listQuery.startTime = startTime
    listQuery.endTime = endTime
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }

  //  获取楼盘列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const res = await getActualSoldPriceListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.roomName = item.floor + (item.roomName.length > 1 ? item.roomName : '0' + item.roomName)
          item.discount = (Math.round(item.actualTotalPrice / item.totalPrice * 10000) / 100).toFixed(2) + '%'
          item.area = item.area.toFixed(2) + '㎡'
          item.price = Math.round(item.price) + '元/㎡'
          item.totalPrice = Math.round(item.totalPrice * 100) / 100 + '万'
          item.actualPrice = Math.round(item.actualPrice) + '元/㎡'
          item.actualTotalPrice = Math.round(item.actualTotalPrice * 100) / 100 + '万'
          item.soldTime = Dayjs(item.soldTime).format('YYYY年MM月DD日')
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
  }, [])

  return (
    <div>
      <div className="pageTitle">真实成交价</div>
      <Card className="card">
        <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
          <Form.Item name="houseName">
            <Input allowClear placeholder="楼盘名关键词" style={{ width: '200px' }} />
          </Form.Item>
          <Form.Item name="evidenceName">
            <Input allowClear placeholder="预售证关键词" style={{ width: '200px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item name="endtime">
            <RangePicker allowClear needConfirm picker="date" placeholder={['网签开始时间', '网签截止时间']} style={{ width: '300px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>
              搜索
            </Button>
          </Form.Item>
        </Form>
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column title="楼盘名" dataIndex="houseName" />
          <Column title="预售证" dataIndex="evidenceName" />
          <Column title="楼栋" dataIndex="buildName" />
          <Column title="单元" dataIndex="unitName" />
          <Column title="房号" dataIndex="roomName" />
          <Column title="面积" dataIndex="area" />
          <Column title="备案单价" dataIndex="price" />
          <Column title="备案总价" dataIndex="totalPrice" />
          <Column title="成交单价" dataIndex="actualPrice" />
          <Column title="成交总价" dataIndex="actualTotalPrice" />
          <Column title="折扣" dataIndex="discount" className="red" />
          <Column title="网签日期" dataIndex="soldTime" />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
